// validators.ts
import { arrayOf, boolean, date, number, object, optional, string } from "justus";
import { uuid } from "justus/extra/uuid";
var deliverySlotValidator = object({
  /** Unique ID of a slot */
  uuid,
  /** The date when the order will be delivered */
  date: string,
  /** Time slot, in the format HH:MM-HH:MM, when the order should be delivered */
  slot: string,
  /** Number of available slots  */
  available: number({ minimum: 0 }),
  /** Number of scheduled deliveries for the slot (visible for admin only) */
  scheduled: optional(number({ minimum: 0 })),
  /** Location UUID of a slot */
  location_uuid: uuid,
  /** UUID of delivery provider who is in charge of handling delivery */
  delivery_provider_uuid: uuid,
  /** The name of the delivery provider */
  delivery_provider_name: string,
  /** Name of the slot */
  name: string,
  /** Shipping fee of the slot */
  shipping_fee: number({ minimum: 0 }),
  /** The date and time when the slot becomes closed for new orders */
  cutoff: date,
  /** Identifies whether the slot is for B2B usage */
  b2b: boolean,
  /** The date when the order should be picked */
  picking_date: string({ pattern: /^\d{4}-\d{2}-\d{2}$/ })
});
var updateDeliverySlotValidator = object({
  available: optional(number({ minimum: 0 })),
  cutoff: optional(date)
});
var createClosureValidator = object({
  country_code: string({ minLength: 2, maxLength: 2 }),
  closure_date: string({ pattern: /^\d{4}-\d{2}-\d{2}$/ }),
  state_codes: arrayOf(string({ minLength: 2, maxLength: 2 })),
  all: optional(boolean)
});
var stateClosureValidator = object({
  /** The country code */
  country_code: string,
  /** The closure date */
  closure_date: string,
  /** Array of states that are closed for the delivery on that day */
  state_codes: arrayOf(string),
  /** Whether the day is closed in all states */
  all: boolean
});
var stateValidator = object({
  name: string,
  state_code: string({ maxLength: 2, minLength: 2 }),
  country_code: string({ maxLength: 2, minLength: 2 })
});
var warehouseCapacityData = {
  mon: number({ minimum: 0 }),
  tue: number({ minimum: 0 }),
  wed: number({ minimum: 0 }),
  thu: number({ minimum: 0 }),
  fri: number({ minimum: 0 }),
  sat: optional(number({ minimum: 0 })),
  sun: optional(number({ minimum: 0 }))
};
var dayConfigData = {
  cutoff_hours: number({ minimum: 0 }),
  picking_before_days: number({ minimum: 0 }),
  shipping_fee: number({ minimum: 0 })
};
var providerTemplateValidator = object({
  slot: string,
  provider: string,
  exclude: optional(arrayOf(string)),
  location_uuid: string,
  priority_over: optional(string),
  days: {
    mon: optional(dayConfigData),
    tue: optional(dayConfigData),
    wed: optional(dayConfigData),
    thu: optional(dayConfigData),
    fri: optional(dayConfigData),
    sat: optional(dayConfigData),
    sun: optional(dayConfigData)
  },
  b2b: optional(boolean)
});
var templateValidator = object({
  carriers: object({
    dpd_b2b: providerTemplateValidator,
    dpd12: providerTemplateValidator,
    dpd18: providerTemplateValidator,
    dhl_at: providerTemplateValidator,
    dhl_de: providerTemplateValidator
  }),
  warehouse_capacity: warehouseCapacityData
});
var updateTemplateValidator = object({
  carriers: optional(object({
    dpd_b2b: optional(providerTemplateValidator),
    dpd12: optional(providerTemplateValidator),
    dpd18: optional(providerTemplateValidator),
    dhl_at: optional(providerTemplateValidator),
    dhl_de: optional(providerTemplateValidator)
  })),
  warehouse_capacity: optional(warehouseCapacityData)
});
export {
  createClosureValidator,
  deliverySlotValidator,
  providerTemplateValidator,
  stateClosureValidator,
  stateValidator,
  templateValidator,
  updateDeliverySlotValidator,
  updateTemplateValidator
};
//# sourceMappingURL=validators.mjs.map
